import { render, staticRenderFns } from "./mntmoduleconfig.vue?vue&type=template&id=35f85bae"
import script from "./mntmoduleconfig.vue?vue&type=script&lang=js"
export * from "./mntmoduleconfig.vue?vue&type=script&lang=js"
import style0 from "./mntmoduleconfig.vue?vue&type=style&index=0&id=35f85bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports